import { ColontitulData, PositionType } from 'interfaces/templates.interface';
import { ICounteragentType, TCounteragentEnum } from 'interfaces/counteragents.interface';
import { IVariableItem } from 'interfaces/variables.interface';

export const case_items = [
  // 'I',
  'R',
  'D',
  // 'V',
  'T'
  //  'P'
];

export const date_items = [
  'A', 'B', 'C', 'D', 'E'
];

export const contragent_types: Record<ICounteragentType, TCounteragentEnum> = {
  entity: 'E', individual: 'IP', person: 'P'
};

export const contragent_default_variables: {
  P: { id: string, required: boolean }[],
  IP: { id: string, required: boolean }[],
  E: { id: string, required: boolean }[],
} = {
  P: [
    { id: '101', required: true },
    { id: '102', required: true },
    { id: '103', required: true },
    { id: '322', required: false }
  ],
  IP: [
    { id: '304', required: true },
    { id: '2006', required: false },
    { id: '101', required: false },
    { id: '102', required: false },
    { id: '103', required: false },
    { id: '306', required: false },
    { id: '307', required: false },
    { id: '308', required: false },
    // { id: '314', required: false },
    { id: '316', required: false },
    { id: '317', required: false },
    { id: '321', required: false },
    { id: '2001', required: false },
  ],
  E: [
    { id: '304', required: true },
    { id: '2006', required: false },
    { id: '302', required: false },
    { id: '305', required: false },
    { id: '306', required: false },
    { id: '307', required: false },
    { id: '308', required: false },
    // { id: '314', required: false },
  ]
};

export const files_icons: { [key: string]: string } = {
  '.bmp': '/icons/file_types/bmp.svg',
  '.csv': '/icons/file_types/csv.svg',
  '.dg2': '/icons/file_types/dg2.svg',
  '.dgr': '/icons/file_types/dgr.svg',
  '.doc': '/icons/file_types/doc.svg',
  '.docx': '/icons/file_types/docx.svg',
  '.forma': '/icons/file_types/forma.svg',
  '.gif': '/icons/file_types/gif.svg',
  '.jpg': '/icons/file_types/jpg.svg',
  '.jpeg': '/icons/file_types/jpg.svg',
  '.key': '/icons/file_types/keynote.svg',
  '.keynote': '/icons/file_types/keynote.svg',
  '.numbers': '/icons/file_types/numbers.svg',
  '.pages': '/icons/file_types/pages.svg',
  '.pdf': '/icons/file_types/pdf.svg',
  '.png': '/icons/file_types/png.svg',
  '.ppt': '/icons/file_types/ppt.svg',
  '.pptx': '/icons/file_types/pptx.svg',
  '.tif': '/icons/file_types/tif.svg',
  '.tiff': '/icons/file_types/tif.svg',
  '.txt': '/icons/file_types/txt.svg',
  '.xls': '/icons/file_types/xls.svg',
  '.xlsx': '/icons/file_types/xlsx.svg',
  '.zip': '/icons/file_types/zip.svg',
  'other': '/icons/file_types/other.svg'
};

export const categories_colors: { [key: string]: { background: string, color: string } } = {
  khaki: { background: '#4E8CC6', color: '#FFFFFF' },
  orange: { background: '#F49F8D', color: '#FFFFFF' },
  red: { background: '#CE7AA8', color: '#FFFFFF' },
  lightpurple: { background: '#2274A5', color: '#FFFFFF' },
  turquoise: { background: '#32AAB7', color: '#FFFFFF' },
  darkgray: { background: '#576490', color: '#FFFFFF' },
  lightgreen: { background: '#66BE94', color: '#FFFFFF' },
  purple: { background: '#A794DF', color: '#FFFFFF' },
  lightblue: { background: '#9DB7E2', color: '#FFFFFF' },
  lightgray: { background: '#969C9E', color: '#FFFFFF' },
  green: { background: '#79BE70', color: '#FFFFFF' },
};

export const currencies: { [key: string]: { code: string, symbol: string } } = {
  ru: {
    code: 'ru-RU',
    symbol: 'RUB'
  },
  en: {
    code: 'en-US',
    symbol: 'USD'
  },
};

export const paymentMethodsData: {
  card: { icons: string[] },
  invoice: { tattrsBase: IVariableItem[], tattrsFull: IVariableItem[] }
} = {
  card: {
    icons: ['/icons/payments/mastercard.svg', '/icons/payments/mir.svg', '/icons/payments/visa.svg']
  },
  invoice: {
    tattrsBase: [
      {
        id: 'companyname', // nonstandard
        lang: 'ru',
        errorMessage: 'Укажите полное наименование на русском языке',
        charset: 'REDS',
        inputTooltip: 'Укажите полное наименование на русском языке',
        inputText: 'Введите название или ИНН для поиска',
        inputWidth: 642, // nonstandard
        labelWidth: 642, // nonstandard
        labelLineCount: 1,
        type: 'string',
        name: 'Наименование организации или ИП'
      },
      {
        id: 'phone', // nonstandard
        lang: 'ru',
        inputText: '+7 XXX XXX XX XX',
        inputWidth: 200,
        labelWidth: 200,
        labelLineCount: 1,
        mask: '+7-XXX-XXX-XX-XX',
        regexp: '^\\+7-\\d{3}-\\d{3}-\\d{2}-\\d{2}',
        type: 'phone',
        name: 'Номер телефона'
      }
    ],
    tattrsFull: [
      {
        id: 'companyname', // nonstandard
        lang: 'ru',
        errorMessage: 'Укажите полное наименование на русском языке',
        charset: 'REDS',
        inputTooltip: 'Укажите полное наименование на русском языке',
        inputText: 'Введите название или ИНН для поиска',
        inputWidth: 864, // nonstandard
        labelWidth: 864, // nonstandard
        labelLineCount: 1,
        type: 'string',
        name: 'Наименование организации или ИП'
      },
      {
        id: 'address', // nonstandard
        lang: 'ru',
        errorMessage: 'Укажите юридический адрес',
        inputTooltip: 'Укажите юридический адрес',
        name: 'Юридический адрес',
        type: 'address',
        labelLineCount: 1,
        inputWidth: 864, // nonstandard
        labelWidth: 864, // nonstandard
        inputText: 'Москва, Новинский б-р, д. 9, офис 11'
      },
      {
        id: 'inn', // nonstandard
        lang: 'ru',
        errorMessage: 'Для ИП - 12 цифр, для Юридического лица - 10 цифр',
        inputTooltip: 'Для ИП - 12 цифр, для Юридического лица - 10 цифр',
        inputText: 'Введите 10 или 12 цифр',
        inputWidth: 200,
        labelWidth: 200,
        labelLineCount: 1,
        maxLength: 12,
        minLength: 10,
        type: 'string',
        name: 'ИНН Юр. лица / ИП',
        regexp: '^(\\d{10}|\\d{12})$' // nonstandard
      },
      {
        id: 'ogrn', // nonstandard
        lang: 'ru',
        errorMessage: 'ОГРН состоит из 13 или 15 цифр', // nonstandard
        inputTooltip: 'Основной государственный регистрационный номер состоит из 13 или 15 цифр', // nonstandard
        name: 'ОГРН',
        type: 'string',
        charset: 'D',
        maxLength: 15, // nonstandard
        minLength: 13, // nonstandard
        // length: 13, nonstandard
        labelLineCount: 1,
        labelWidth: 200,
        inputWidth: 200,
        inputText: '1197777777777',
        regexp: '^(\\d{13}|\\d{15})$' // nonstandard
      },
      {
        id: 'kpp', // nonstandard
        lang: 'ru',
        name: 'КПП',
        type: 'string',
        charset: 'D',
        length: 9,
        labelLineCount: 1,
        inputWidth: 200, // nonstandard
        labelWidth: 200, // nonstandard
        inputText: 'Введите КПП',
        inputTooltip: 'КПП состоит из 9 цифр',
        errorMessage: 'КПП состоит из 9 цифр'
      }
    ]
  }
};

// R: 'Кириллица',
// E: 'Латинница',
// D: 'Цифры',
// S: 'Символы'

export const organizationTattrs: IVariableItem[] = [
  {
    id: 'companyname', // nonstandard
    lang: 'ru',
    errorMessage: 'Укажите полное наименование на русском языке',
    charset: 'REDS',
    inputTooltip: 'Укажите полное наименование на русском языке',
    inputText: 'Введите название или ИНН для поиска',
    inputWidth: 864, // nonstandard
    labelWidth: 864, // nonstandard
    labelLineCount: 1,
    type: 'string',
    name: 'Полное наименование организации или ИП'
  },
  {
    id: 'address', // nonstandard
    lang: 'ru',
    errorMessage: 'Укажите юридический адрес',
    inputTooltip: 'Укажите юридический адрес',
    name: 'Юридический адрес',
    type: 'address',
    labelLineCount: 1,
    inputWidth: 864, // nonstandard
    labelWidth: 864, // nonstandard
    inputText: 'Москва, Новинский б-р, д. 9, офис 11'
  },
  {
    id: 'inn', // nonstandard
    lang: 'ru',
    errorMessage: 'Для ИП - 12 цифр, для Юридического лица - 10 цифр',
    inputTooltip: 'Для ИП - 12 цифр, для Юридического лица - 10 цифр',
    inputText: 'Введите 10 или 12 цифр',
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    maxLength: 12,
    minLength: 10,
    type: 'string',
    name: 'ИНН Юр. лица / ИП',
    regexp: '^(\\d{10}|\\d{12})$' // nonstandard
  },
  // {
  //   id: 'ogrn', // nonstandard
  //   lang: 'ru',
  //   errorMessage: 'ОГРН состоит из 13 или 15 цифр', // nonstandard
  //   inputTooltip: 'Основной государственный регистрационный номер состоит из 13 или 15 цифр', // nonstandard
  //   name: 'ОГРН',
  //   type: 'string',
  //   charset: 'D',
  //   maxLength: 15, // nonstandard
  //   minLength: 13, // nonstandard
  //   // length: 13, nonstandard
  //   labelLineCount: 1,
  //   labelWidth: 200,
  //   inputWidth: 200,
  //   inputText: '1197777777777',
  //   regexp: '^(\\d{13}|\\d{15})$' // nonstandard
  // },
  {
    id: 'kpp', // nonstandard
    lang: 'ru',
    name: 'КПП',
    type: 'string',
    charset: 'D',
    length: 9,
    labelLineCount: 1,
    inputWidth: 200, // nonstandard
    labelWidth: 200, // nonstandard
    inputText: 'Введите КПП',
    inputTooltip: 'КПП состоит из 9 цифр',
    errorMessage: 'КПП состоит из 9 цифр',
    hidden: true
  },
  // {
  //   id: 'email', // nonstandard
  //   lang: 'ru',
  //   name: 'Email',
  //   type: 'email',
  //   labelLineCount: 1,
  //   inputWidth: 200,
  //   labelWidth: 200,
  //   inputText: 'ivan@mail.ru',
  //   inputTooltip: 'Введите email в формате name@domain.ext',
  //   errorMessage: 'Не корректный формат email'
  // },
  // {
  //   id: 'phone', // nonstandard
  //   lang: 'ru',
  //   inputText: '+7 XXX XXX XX XX',
  //   inputWidth: 200,
  //   labelWidth: 200,
  //   labelLineCount: 1,
  //   mask: '+7-XXX-XXX-XX-XX',
  //   regexp: '^\\+7-\\d{3}-\\d{3}-\\d{2}-\\d{2}',
  //   type: 'phone',
  //   name: 'Номер телефона'
  // }
];

export const colontitulPositionList: PositionType[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right'
];

export const colontitulDefaultData: ColontitulData['data'] = {
  type: 'text',
  text: '',
  startPage: 1,
  displayOnFirstPage: true,
  hideOnPages: []
};

export const miniToolbar = {
  toolbar: {
    items: ['bold', 'italic', 'underline', 'fontBackgroundColor'],
  },
};

export const templatesIcons = {
  grid: {
    folders: {
      default: '/icons/explorer/folder.svg',
      static: '/icons/explorer/folder_forma_main.svg',
      strict: '/icons/explorer/folder_forma.svg',
      packs: '/icons/explorer/folder_packs.svg',
      trash: '/icons/explorer/folder_trash.svg',
      created: '/icons/explorer/folder.gif',
      private: '/icons/explorer/folder_locked.svg',
      privateAdd: '/icons/explorer/folder_lock.svg',
      privateHover: '/icons/explorer/folder_locked_hover.svg',
      back: '/icons/explorer/folder_back.svg',
    },
    files: {
      default: '/icons/explorer/file_i.svg',
      strict: '/icons/explorer/file_forma.svg',
      created: '/icons/explorer/file_i.gif',
    },
    packs: {
      default: '/icons/explorer/templates_pack.svg',
      hover: '/icons/explorer/templates_pack_hover.svg',
    }
  },
  list: {
    folders: {
      default: '/icons/explorer/folder_small.svg',
      static: '/icons/explorer/folder_forma_main_small.svg',
      strict: '/icons/explorer/folder_forma.svg',
      trash: '/icons/explorer/folder_trash.svg',
      empty: '/icons/explorer/folder_empty_small.svg',
      private: '/icons/explorer/folder_locked_small.svg',
      packs: '/icons/explorer/folder_packs.svg',

    },
    files: {
      default: '/icons/explorer/file_i_small.svg',
      strict: '/icons/explorer/file_forma.svg',
    },
    packs: {
      default: '/icons/explorer/templates_pack_small.svg',
      hover: '/icons/explorer/templates_pack_hover.svg',
    }
  }
};

export const linkedTableTattrs = [
  {
    tattrId: '3160',
    columnId: 'VAT'
  }
];

export const defaultProductsColumns = [
  'number',
  'name',
  'count',
  'unit',
  'price',
  'VAT'
];

export const defaultProductsTotal = [
  'totalVAT',
  'totalPrice'
];
